<template>
  <div class="col-6">
    <card-loader ref="content" title="Gráfico de estados">
      <horizontal-bar-chart v-if="chartData" :chart-data="chartData" :options="options" :show-data-labels="true" />
    </card-loader>
  </div>
</template>

<script>
import HorizontalBarChart from '../../../components/Charts/HorizontalBarChart';
import CardLoader from '../../../components/Cards/CardLoader';
import ChartCampaignMixin from '@/mixins/chartCampaignMixin';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  components: {
    HorizontalBarChart,
    CardLoader,
  },

  mixins: [ChartCampaignMixin],
  props: {
    campaign: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      chartData: null,
      options: null,
    };
  },

  computed: {
    ...mapState('models/projection', {
      currentTableSearch: (state) => state.currentTableSearch,
    }),

    ...mapGetters('models/projection', ['getStateByLabel']),
  },

  mounted() {
    this.resetState();
    this.renderChart(this.campaign, this.currentTableSearch, this.distributorId);
  },

  methods: {
    ...mapActions('charts', ['setState']),
    async renderChart(campaign, search, distributor) {
      const { values, labels } = await this.$refs.content.resolve(
        this.$services.resource('projection_charts').state({ campaign, search, distributor })
      );

      if (values && labels) {
        this.options = {
          scales: {
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },

          responsive: true,
          maintainAspectRatio: false,
          onClick: this.clickColumn,
          plugins: {
            datalabels: { ...this.dataLabelsOptions, ...{ align: 'right' } },
          },
        };

        this.chartData = {
          labels,
          datasets: [
            {
              label: `Estados Proyecciones ${this.currentCampaignName}`,
              backgroundColor: this.colorBlue,
              data: values,
            },
          ],
        };
      }
    },

    clickColumn(point, event) {
      this.$emit('chartSearch');
      const state = this.getStateByLabel(event[0]._model.label);
      this.setState(state.id);
      this.$router.push({ name: 'ProjectionsList' });
    },

    resetState() {
      this.setState(null);
    },
  },
};
</script>
